<template>
  <div
    class="row"
  >
    <div class="col-md-6 d-flex">
      <v-card title="Personal Details">
        <v-definition-list
          :data="getTAPersonalDetails()"
        />
      </v-card>
    </div>
    <div class="col-md-6 d-flex">
      <v-card
        title="Competency Details"
      >
        <div class="card-cd">
          <v-button
            size="lg"
            :disabled="isCOmpetencyPDFUploaded()"
            has-min-width
            @click="viewTACompetency"
          >
            View Competencies
          </v-button>
          <div>
            If additions to your competency are required, please refer to the Service Descriptor
            documents located in Useful Resources
          </div>
          <v-button
            size="lg"
            :disabled="false"
            class="btn-cac"
            has-min-width
            @click="submitCAC"
          >
            Continuing Assessor Competence
            <div class="btn-cac-desc">
              Maintenance of technical knowledge and skills
              <br>
              {{ cacUpdateNextDueStr }}
            </div>
          </v-button>
        </div>
      </v-card>
    </div>
    <div class="col-md-6 d-flex">
      <v-card title="Email Details">
        <div class="col-md-12 d-flex gap-in-list">
          <div class="col-md-2">
            Type
          </div>
          <div class="col-md-8">
            Email
          </div>
          <div class="col-md-2 primaryTitle">
            Primary
          </div>
        </div>
        <div
          v-for="item in currentUser.user_info.csv_info.emails"
          :key="item.Type"
          class="col-md-12 d-flex gap-in-list"
        >
          <div class="col-md-2">
            <strong>{{ item.Type }}:</strong>
          </div>
          <div class="col-md-8">
            <strong>{{ item.email }}</strong>
          </div>
          <div class="col-md-2 primaryTitle">
            <v-icon
              v-if="item.isPrimary"
              type="check-circle"
              class="selected-icon"
            />
          </div>
        </div>
      </v-card>
    </div>
    <div class="col-md-6 d-flex">
      <v-card title="Phone Details">
        <div class="col-md-12 d-flex gap-in-list">
          <div class="col-md-2">
            Type
          </div>
          <div class="col-md-8">
            Phone
          </div>
          <div class="col-md-2 primaryTitle">
            Primary
          </div>
        </div>
        <div
          v-for="item in currentUser.user_info.csv_info.phones"
          :key="item.phoneNumber"
          class="col-md-12 d-flex gap-in-list"
        >
          <div class="col-md-2">
            <strong>{{ item.Type }}:</strong>
          </div>
          <div class="col-md-8">
            <strong>{{ item.countryCode + item.phoneNumber }}</strong>
          </div>
          <div class="col-md-2 primaryTitle">
            <v-icon
              v-if="item.isPrimary"
              type="check-circle"
              class="selected-icon"
            />
          </div>
        </div>
      </v-card>
    </div>
    <div
      v-for="(item, index) in currentUser.user_info.csv_info.addresses"
      :key="index"
      class="col-md-6 d-flex"
    >
      <v-card
        :title="getAddressTitle(item)"
      >
        <div class="row">
          <div class="col-md-12">
            <div
              v-if="item.isPrimary"
              class="address-primary"
            >
              Primary&nbsp;&nbsp;&nbsp;
              <v-icon
                type="check-circle"
                class="selected-icon"
              />
            </div>
          </div>
          <div
            class="col-md-12"
            :style="item.isPrimary?'':'margin-top:20px;'"
          >
            <v-definition-list
              :data="updateAddressDetails(item)"
            />
          </div>
        </div>
      </v-card>
    </div>
    <v-modal
      v-show="showCacOptionModal"
      ref="appmodal"
      :custom-class="'cac_modal'"
      :modal-container-custom-class="'cac-modal-content'"
      @close="closeCacOptionModal"
    >
      <template #header>
        Technical Assessor's Acknowledgement
      </template>
      <template>
        <div>
          <div>
            <p>
              The NATA peer review process relies on the expertise and contemporary knowledge of its volunteer technical assessors.
            </p>
            <p>
              As a technical assessor I hereby confirm that I remain current in the areas for which I am deemed competent as an assessor.
            </p>
            <p>
              (please tick the appropriate box(es) to indicate how continuing competence (CC) has been maintained)
            </p>
            <p>
              <i>
                (Note: NATA may request evidence as appropriate, and your submission may be subject to review by the Accreditation Advisory Committee)
              </i>
            </p>
            <!-- <p>{{ selectedChange }}</p> -->
          </div>
          <div class="cac-option-container">
            <div
              v-for="(option,index) in cacUserOptions"
              :key="index"
              class="cac-option"
            >
              <v-checkbox
                :id="index"
                @check="checkIn(option)"
              >
                <div>
                  {{ option.title }}
                  <div
                    v-if="option.desc"
                    class="desc"
                  >
                    {{ option.desc }}
                  </div>
                </div>
              </v-checkbox>
              <div
                v-if="option.showTextInput"
                class="txt-area"
              >
                <v-textarea
                  :maxlength="'255'"
                  :disabled="!selectedOther"
                  :value="selectedOther? selectedOther.associatedText : ''"
                  class="fieldset__input"
                  :class="textAreaBorderColor()? 'borderRed' : ''"
                  @input="inputValue"
                />
              </div>
            </div>
          </div>
          <div>
            <p>
              Refresh your skills now by doing a training course with NATA Education,
              <a
                class="btn--secondary"
                href="mailto: nataeducation@nata.com.au"
              >contact us now </a>
              to learn more.
            </p>
          </div>
        </div>
      </template>
      <template #footer>
        <div style="margin-bottom: -15px;">
          <p style="text-align: left;">
            <i>
              Technical Assessor activities in relation to NATA assessment activities are not considered to maintain technical skills in their own right
            </i>
          </p>
        </div>
        <v-button-group is-inline>
          <v-button
            size="l"
            has-min-width
            :disabled="isCacSubmitDisabled"
            @click="performCacSubmit"
          >
            Submit
          </v-button>
          <v-button
            size="l"
            has-min-width
            @click="closeCacOptionModal"
          >
            Cancel
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </div>
</template>
<script>
  import Button from "@/atoms/Button";
  import Card from "@/molecules/Card";
  import DefinitionList from "@/atoms/DefinitionList";
  import {buildBreadCrumb, buildDefinitionList} from "@/common/tableFunctions";
  import Icon from "@/atoms/Icon";
  import constants from "@/common/constants";
  import ApiService from "@/common/apiService";
  import Modal from "@/atoms/Modal";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Checkbox from "@/atoms/Checkbox";
  import Textarea from "@/atoms/Textarea";
  import moment from 'moment';


  export default {
    name: "ProfileTA",
    components: {
      'v-button': Button,
      'v-card': Card,
      "v-definition-list": DefinitionList,
      "v-icon": Icon,
      "v-modal": Modal,
      "v-button-group": ButtonGroup,
      "v-checkbox": Checkbox,
      "v-textarea": Textarea,
    },
    props: {
      currentUser: {
        type: Object,
        default: null
      },
      profileViewType: {
        type: String,
        default: 'SELF'
      }
    },
    data: () => ({
      showCacOptionModal: false,
      isCacSubmitDisabled: true,
      cacUpdated_at: null,
      cacUpdateNextDueStr: null,
      selectedChange:[],
      selectedOther: null,
      cacUserOptions: constants.cacUserOptions
    }),
    computed: {
        // ...mapState({
        //   currentUser: state => state.auth.user,
        // }),
    },
    mounted(){
      this.cacUpdated_at = this.currentUser.user_info.cacUpdated_at;
      this.nextCacDueOn();
    },
    methods:{
      getTAPersonalDetails() {
        let details  = [];
        details['Position Title'] = this.currentUser.title;
        details['First Name'] = this.currentUser.first_name;
        details['Last Name'] = this.currentUser.last_name;
        if(this.currentUser.resource_id)
          details['TA ID'] = this.currentUser.resource_id;

        return buildDefinitionList(details);
      },
      viewTACompetency() {
        let url = this.profileViewType == 'ADMIN'?`/admin/ta/competencypdf/${this.currentUser.id}`:'/activeuser/competencypdf'
        ApiService.get(url)
                .then(response => {
                    if(response.data.data) {
                      window.open(response.data.data, '_blank');
                      this.$emit('viewedCompetencyPDF', true);
                    }
                    else
                      this.$notify({
                        title: 'Error',
                        text:'Competency PDF is not available yet. Please contact administrator.',
                        type: 'error'
                      });
                })
                .catch(error => {
                  this.$notify({
                      title: 'Error',
                      text:'Competency PDF is not available yet. Please contact administrator.',
                      type: 'error'
                    });
                });
      },
      getAddressTitle(item) {
        return item.Type + ' Address';
      },
      updateAddressDetails(item) {
        let billing_details = [];
        // let user = this.currentUser;
        billing_details['Address'] = item.AddressLine;
        billing_details['Suburb'] = item.Suburb;
        billing_details['Country'] = item.Country;
        billing_details['State'] = (!item.Country && item.State == 'Other')?null:item.State;
        billing_details['Post Code'] = item.Postcode;
        return buildDefinitionList(billing_details);
      },
      isCOmpetencyPDFUploaded() {
        return !(this.currentUser.user_info.competency_pdf_uri && this.currentUser.user_info.competency_pdf_uri.indexOf(this.currentUser.resource_id) !== -1);
      },
      submitCAC() {
        document.body.style.overflow = "hidden";
        this.showCacOptionModal = true;
      },
      closeCacOptionModal() {
        // this.updateUserAction('', null, false, false);
        document.body.style.overflow = "auto";
        this.showCacOptionModal = false;
        // this.adminNotifyTitle = null;
        // this.adminNotifyBody = null;
      },
      nextCacDueOn() {
        if(this.cacUpdated_at) {
          this.cacUpdateNextDueStr = 'Next due on: '+moment(this.cacUpdated_at).add(2, 'years').format("DD/MM/YYYY");
        }
        return '';
      },
      performCacSubmit() {
        this.showCacOptionModal = false;
        this.selectedChange = this.selectedChange.sort((a, b) => a.id - b.id)
        ApiService.post("/user-requests/ta/cac/update", this.selectedChange)
          .then(({ data }) => {
            this.cacUpdated_at = data.data.cacUpdated_at;
            this.nextCacDueOn();
            this.$notify({
              title: 'Success',
              text: data.data.message,
              type: 'success'
            });
          })
          .catch(({ response }) => {
            this.$notify({
              title: 'Error',
              text: response.data.message?response.data.message:'Unable to upload selected document. Try again or contact administrator.',
              type: 'error'
            });
          }).finally(()=> {
            //this.$refs.uploadmodal.closeModal();
          })
      },
      checkIn(index) {
        this.isCacSubmitDisabled = true;
        if(!this.selectedChange.includes(index))
        {
          this.selectedChange.push(index)
        }else{
          this.selectedChange.splice(this.selectedChange.findIndex(o => o == index), 1)
        }

        let otherOption = this.selectedChange.filter(ele => ele.id == 15)
        if(otherOption && otherOption[0]) {
          if(!this.selectedOther) {
            this.selectedOther = otherOption[0];
            this.selectedOther.associatedText = '';
          }
        }else {
          this.selectedOther = null;
        }

        if(this.selectedChange.length > 0) {
            this.isCacSubmitDisabled = false;
            this.isAssociatedTextEntered();
        }
      },
      inputValue: function (data) {
        if(this.selectedOther) {
          this.selectedOther.associatedText = data;
        }
        this.isAssociatedTextEntered();
      },
      isAssociatedTextEntered() {
        if(this.selectedOther && this.selectedOther.associatedText.trim() == '') {
            // Check if text entered or not.
              this.isCacSubmitDisabled = true;
          }else
            this.isCacSubmitDisabled = false;
      },
      textAreaBorderColor() {
        return this.selectedOther && this.selectedOther.associatedText.trim() == ''
      }
    }
  }
</script>
<style lang="scss">
@import "../styles/shared/shared";

  .selected-icon {
    font-size: 1.5em;
    color: $azure;
    display: flex;
  }
  .primaryTitle {
    display: flex;
    justify-content: center;
  }
  .address-primary {
    display: flex;
    justify-content: flex-end;
    color: $azure;
    font-weight: bolder;
  }
  .gap-in-list {
    margin-bottom: 1rem;
  }
  .card-cd {
    display: flex;
    flex-direction: column;
    gap: 5px;
    .btn-cac {
      background-color: $cacBlue;
      color: $white;
    }
    .btn-cac-desc {
        font-size: 12px; min-width: 350px;
      }
  }
  .cac-modal-content {
    height: 100%;
    max-width: 98%;
    width: 98%;
    border-top: none;
    max-height: 100%;
    .modal__header {
      background-color: $cacBlue;
      margin-bottom: 0px;
      h2 {
        color: $white;
        text-align: center;
      }
    }
    .modal__footer {
      text-align: center;
    }
  }
  .cac_modal {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    div {
      div {
        p {
          margin: 0px;
          line-height: 1.5rem;
        }
      }
    }
    }
    .cac-option-container {
      margin: 1rem 0rem 1rem 0rem;
      .cac-option {
        padding-top: 0.75rem;
        .checkbox__label {
          width: 100%;
        }
        .desc {
          margin-left: 1rem;
          font-size: 0.7rem;
          line-height: 0.7rem;
        }
      .txt-area {
        margin-left: 3rem;
      }
      .borderRed {
        border-color: red;
      }
    }
  }

</style>

